<template>

    <div class="app-card" >
        <div class="head">
            <h3>{{ params.title }} </h3>
            <div >Status: {{params.state}}</div>
           
            <div class="icons">
                    <IconButton
                    v-if="true"
                    v-tooltip="`Terminate job`"
                    :icon="'trash'"
                    :width="22"
                    :height="22"
                    :type="'click'"
                    @click="terminateJob(params.job_id)"
                  />
            </div>

        </div>
    
        <div class="body__grid">

          <div class="body__grid-field">
          <div class="description">Launched</div>
          <div class="value">{{ startTime}}</div>
          </div>

          <div class="body__grid-field">
          <div class="description">Job ID</div>
          <div class="value">{{ params.job_id }}</div>
          </div>

        </div>
    </div>
    
</template>

<script setup>
import {ref,  computed,defineProps } from 'vue';
import IconButton from '@/components/IconButton.vue';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

const $toast = useToast();
const dataConnect = new DatastoreConnect();

const props = defineProps({
  params: {
    type: Object,
    required: true,
  },
});


const loading = ref(false);

function terminateJob(id) {
    dataConnect.api('job.stop',{job_id:id})
    .then((ret) => {
        if(ret.result) 
        {
            const $toast = useToast();
            $toast.open({
                queue: true,
                duration: 5000,
                message: "Job Terminated, ID:"+ret.result.job_id,
                type: 'success',
                position: 'top',
            });

            emit('job_terminated',ret.result.job_id)

        }
        else if(ret.error){
            const $toast = useToast();
            $toast.open({
                queue: true,
                duration: 5000,
                message: ret.error.message,
                type: 'error',
                position: 'top',
            });
        }
    })
    .catch((error) => {
        console.log(error);
        return '';
        });
    

}

const startTime = computed (()=> {
  const v=props.params.launch
  return formatTime(v);

});

function formatTime(str) {
  return `${new Date(str).toLocaleTimeString('default', {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,
  })}`;
}


</script>

<style lang="scss" scoped>
.app-card {
  width: 80%;
  border: 1px solid rgb(156, 155, 155);
  display: flex;
  flex-direction: column;
  position: relative;
  height: fit-content;
  padding: 0;
  margin: 0;
  text-align: left;
  overflow: hidden;
  border-radius: 8px;
  margin: 10px;
  box-shadow: 2px 2px 6px 6px rgba(162, 162, 162, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
}

.head {
    background: rgb(227, 227, 227);
    padding: 2px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    padding-left: 8px;
    padding-right: 8px;
    justify-content: space-between;
   
}

.icons {
    //margin-left: auto;
}

</style>